/**
 * Aggregates experience line-item totals keyed by bundle id (same shape as
 * getAccommodationBreakdownView) so accommodation payment totals can include
 * bundled experience amounts that are excluded from standalone experience totals.
 */
export function buildBundledExperienceTotalsById(
  experienceItems: Array<App.Checkout.ExperienceItemView>,
): Record<string, { price: number, memberPrice: number }> {
  const bundledExperienceTotalsById: Record<string, { price: number, memberPrice: number }> = {}
  for (const view of experienceItems) {
    if (!view.item.isAccomBundle) continue
    const bundleId = view.item.isAccomBundle
    const existing = bundledExperienceTotalsById[bundleId] ?? { price: 0, memberPrice: 0 }
    bundledExperienceTotalsById[bundleId] = {
      price: existing.price + (view.totals.price ?? 0),
      memberPrice: existing.memberPrice + (view.totals.memberPrice ?? 0),
    }
  }
  return bundledExperienceTotalsById
}
